import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RainbowKitProvider } from '@rainbow-me/rainbowkit'
import { createWeb3Modal } from '@web3modal/wagmi/react'
import App from './App'
import { config } from './lib/web3-config'
// Use the same AuthProvider as pages to ensure context compatibility
import { AuthProvider } from '../../projects/test-project/src/web3/hooks/useAuth'
import { ErrorBoundary } from './components/ErrorBoundary'
import '@rainbow-me/rainbowkit/styles.css'
import './index.css'

/**
 * CRITICAL: Initialize Web3Modal at module top-level
 *
 * This MUST be called synchronously at module load before ReactDOM.render()
 * to prevent "Please call createWeb3Modal before using useWeb3Modal" errors.
 */
const web3Modal = createWeb3Modal({
  wagmiConfig: config,
  projectId: 'ee35dbf49aebc9f7678bafb8c883706d',
  themeMode: 'dark',
  themeVariables: {
    '--w3m-accent': '#7B3FE4',
  },
  // MetaMask browser extension is auto-detected via EIP-6963
  featuredWalletIds: [
    '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4', // Binance Wallet
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0', // Trust Wallet
  ],
})

// Verify initialization succeeded
if (!web3Modal) {
  throw new Error('Web3Modal initialization failed')
}

// Force reference to prevent tree-shaking
// eslint-disable-next-line no-console
console.log('[farcana-app] Web3Modal initialized:', !!web3Modal)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider>
            <AuthProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </AuthProvider>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
